import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../config/config';
import {
  IEducation,
  IEducationRequest,
  IEducationResponse,
} from '../../interfaces/education.interface';
import { baseQueryWithInterceptor } from '../utils/baseQueryWithInterceptor';

const userEducationApi = createApi({
  reducerPath: 'userEducationApi',
  baseQuery: baseQueryWithInterceptor(`${config.API_BASE_URL}/user-education`),
  tagTypes: ['userEducation'],

  endpoints: (builder) => ({
    getMyEducation: builder.query<IEducation[], void>({
      query: () => '',
      providesTags: ['userEducation'],
      transformResponse: (response: IEducationResponse[]) => {
        return response.map(
          ({
            id,
            university,
            specialty,
            idSpecialty,
            idUniversity,
            level,
            userId,
            startYear,
            endYear,
            createdAt,
            updatedAt,
          }) => ({
            educationId: id,
            university,
            specialty,
            idSpecialty,
            idUniversity,
            level,
            userId,
            startYear,
            endYear,
            createdAt,
            updatedAt,
          })
        );
      },
    }),
    createUpdateEducation: builder.mutation<
      IEducationResponse[],
      IEducationRequest
    >({
      query: (data: IEducationRequest) => {
        return {
          url: `/save`,
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: ['userEducation'],
    }),
    deleteEducation: builder.mutation<IEducationResponse, string>({
      query(id) {
        return {
          url: `/${id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['userEducation'],
    }),
  }),
});

export const {
  useGetMyEducationQuery,
  useCreateUpdateEducationMutation,
  useDeleteEducationMutation,
} = userEducationApi;

export default userEducationApi;
